import React  from "react";
import rightImgDemo from "../assets/promo3.png";
import backgroundLineSvg from "../assets/BackgroundLine.svg";
import { MdArrowRightAlt } from "react-icons/md";

const Promo = () => {
  return (
    <div className="">
      <div className="relative grid grid-cols-2 bg-gray-50 mb-[100px]  lg:flex-row  rounded-2xl sm:rounded-[40px] py-[90px] pb-20 sm:p-5 sm:pb-0 lg:p-24">
        <div className="absolute inset-0">
          <img
            fill
            className="absolute w-full h-full object-contain object-bottom dark:opacity-5"
            src={backgroundLineSvg}
            alt="backgroundLineSvg"
          />
        </div>

        <div className="ml-[70px] lg:w-[50%] max-w-lg relative">
          <h2 className="font-semibold text-4xl md:text-5xl">
            {`Don't miss out on special offers`}
          </h2>
          <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
            Register to receive news about the latest, savings combos, discount
            codes...
          </span>
          <ul className="space-y-4 mt-10">
            <li className="flex items-center space-x-4">
              <span className="px-2.5 py-1 rounded-full font-medium text-blue-800 bg-yellow-100">01</span>
              <span className="font-medium text-gray-600">
                Savings combos
              </span>
            </li>
            <li className="flex items-center space-x-4">
            <span className="px-2.5 py-1 rounded-full font-medium text-purple-800 bg-purple-100">02</span>
              <span className="font-medium text-gray-600">
                Freeship
              </span>
            </li>
            <li className="flex items-center space-x-4">
            <span className="px-2.5 py-1 rounded-full font-medium text-blue-800 bg-green-100">03</span>
              <span className="font-medium text-gray-600">
                Premium magazines
              </span>
            </li>
          </ul>
          <form className="mt-10 relative max-w-sm">
            <input
              required
              aria-required
              placeholder="Enter your email"
              type="email"
              rounded="rounded-full"
              className="border rounded-full px-[100px] py-[10px] text-start"
            />
            <button
              type="submit"
              className="absolute transform top-1/2 bg-slate-600 rounded-3xl p-[10px] -translate-y-1/2 right-1"
            >
              <MdArrowRightAlt className="w-6 h-6" />
            </button>
          </form>
        </div>

        <img
          alt=""
          className="absolute  left-[740px] top-[20px]"
          src={rightImgDemo}
          height={500}
          width={500}
          
        />
      </div>
    </div>
  )
}

export default Promo